import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=b67cd534&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=b67cd534&prod&scoped=true&lang=css"
import style1 from "./UserEdit.vue?vue&type=style&index=1&id=b67cd534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67cd534",
  null
  
)

export default component.exports